import React from "react";

const NoDataText = ({
  announcement = "No Data Available",
  data = "-",
  className = "",
}) => {
  return (
    <>
      <span className="sr-only">{announcement}</span>
      <span aria-hidden={true} className={className}>
        {data}
      </span>
    </>
  );
};

export default NoDataText;
